// * GET =====================================
export const VIEW_PRESET_GET_GET_BY_VIEW_ID = `/view_preset/get_by_view_id`;

// * PATCH ===================================

// * POST ====================================
export const VIEW_PRESET_POST_GET_BY_CONTEXT_PROPERTIES = `/view_preset/get_by_context_properties`;

export const VIEW_PRESET_POST_UPDATE_BY_ID = `/view_preset/update_by_id`;

// * DELETE ==================================
export const VIEW_PRESET_DELETE_DELETE_BY_ID = (viewPresetId: string) =>
  `/view_preset/delete_by_id/${viewPresetId}`;

// * PUT =====================================
export const VIEW_PRESET_PUT_CREATE = `/view_preset/create`;
